<template>
  <div class="AuthorColumn">
    <div class="title" v-if="isShowTitle">
        <span>{{dataTitle}}</span>
        <span v-show="hasMore===1" class="more" @click="toMore">更多<img src="@/assets/icon_jump.png"></span>
    </div>
    <div class="list">
        <div class="item" v-for="(item, key) in list" :key="key" @click="clickOpen(item)">
            <div class="item-head">
                <div class="head-title">{{ item.title }}</div>
                <div class="head-view">浏览量 {{ item.look }} 次</div>
            </div>
            <div class="item-banner">
                <img :src="item.icon" >
                <div class="item-desc">
                    {{ item.comment|commentFilter }}
                </div>
            </div>
            <div class="item-foot">
                <span class="know">了解作者 <img style="display:none" src="@/assets/icon_jump.png"></span>
                <button @click.stop="lookOver(item)">查看课程</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { cblockItem, openWindow } from '@/api/app'
import { lookNumber } from '@/api/detail'
import { money } from '@/utils/index'
import { substring } from '@/utils/index'
export default {
  name: 'LineColumn',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  filters: {
    money,
    commentFilter(comment) {
      return substring(comment, 45, true)
    }
  },
  data () {
    return {
    }
  },
  methods: {
      toMore: function(item){
        this.$emit('clickMore', this.dataId, this.dataTitle);
      },
      clickOpen: function(item){
        lookNumber({id: item.id}).then(()=>{
          cblockItem(item, this)
        })
      },
      lookOver: function(item){
        openWindow(0,'/play',{id: item.album}, this)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.AuthorColumn{
  padding: 8px 16px;
  color: #333;
}
.AuthorColumn .title{
  display: flex;
  justify-content:space-between;
  font-size: 16px;
  font-weight:bold;
  padding: 12px 0;
}
.AuthorColumn .title .more{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 100;
    color: #AAA;
}
.AuthorColumn .title img{
    width: 16px;
}
.AuthorColumn .list{
  display: flex;
  flex-wrap: wrap;
  justify-content:space-between;
}
.AuthorColumn .list .item{
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
  color: #999;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.06);
}
.AuthorColumn .list .item .item-head{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 16px 8px;
}
.AuthorColumn .list .item .item-head .head-title{
    color: #333;
    font-size: 16px;
}
.AuthorColumn .list .item .item-head .head-view{
    font-size: 14px;
}
.AuthorColumn .list .item .item-banner{
    position: relative;
}
.AuthorColumn .list .item .item-banner > img{
    width: 100%;
    display: inherit;
}
.AuthorColumn .list .item .item-banner .item-desc{
    width: calc(100% - 16px);
    text-align: left;
    background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
    position: absolute;
    bottom: 0;
    padding: 8px 8px;
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
}
.AuthorColumn .list .item .item-foot{
    padding: 12px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.AuthorColumn .list .item .item-foot>button{
    border-radius:4px;
    border:1px solid rgba(0,133,255,1);
    font-size:14px;
    color:rgba(0,133,255,1);
    background-color: #fff;
    padding: 7px 18px;
}
.AuthorColumn .list .item .item-foot>button:focus,
.AuthorColumn .list .item .item-foot>button:active:focus,
.AuthorColumn .list .item .item-foot>button.active:focus,
.AuthorColumn .list .item .item-foot>button.focus,
.AuthorColumn .list .item .item-foot>button:active.focus,
.AuthorColumn .list .item .item-foot>button.active.focus{
    outline: none;
    box-shadow:none;
}
.AuthorColumn .list .item .item-foot .know{
    display: flex;
    align-items: center;
}
.AuthorColumn .list .item .item-foot .know>img{
    width: 16px;
}
</style>
